export const GET_ISSUE_LOGS = 'GET_ISSUE_LOGS';
export const GET_ISSUE_LOGS_SUCCESS = 'GET_ISSUE_LOGS_SUCCESS';
export const GET_ISSUE_LOGS_ERROR = 'GET_ISSUE_LOGS_ERROR';

export const GET_REPORED_LOGS = 'GET_REPORED_LOGS';
export const GET_REPORED_LOGS_SUCCESS = 'GET_REPORED_LOGS_SUCCESS';
export const GET_REPORED_LOGS_ERROR = 'GET_REPORED_LOGS_ERROR';
